import React from 'react';
import useToggle from '../../Hooks/useToggle';
import BackToTop from '../BackToTop';
import FooterHomeOne from '../HomeSix/FooterHomeSix';
import Drawer from '../Mobile/Drawer';
import HeaderNews from '../HomeSix/HeaderHomeSix';
import HeroNews from '../News/HeroNews';
import Forms from './Forms';

function Contact() {
    const [drawer, drawerAction] = useToggle(false);
    return (
        <>
            <Drawer drawer={drawer} action={drawerAction.toggle} />
            <HeaderNews action={drawerAction.toggle}  />

            <Forms />
            <FooterHomeOne />
            <BackToTop />
        </>
    );
}

export default Contact;
